import ArticleTemplate from '@/pages/article/components/ArticleTemplate';

export default function ArticleFashion() {
  return <ArticleTemplate slug="sugargoo-fashion-guide" />;
}